import { List } from 'immutable';

const defaultPasteSupport = {
  inlineStyles: List([
    'BOLD',
    'CODE',
    'ITALIC',
    'STRIKETHROUGH',
    'UNDERLINE',
    'SUBSCRIPT',
    'SUPERSCRIPT',
  ]),
  blockTypes: List([
    'header-one',
    'header-two',
    'header-three',
    'header-four',
    'header-five',
    'header-six',
    'unordered-list-item',
    'ordered-list-item',
    'blockquote',
    'atomic',
    'code-block',
    'unstyled',
  ]),
  images: false,
  links: true,
};

export function getPasteSupport({
  disabledInlineStyles = [],
  disabledBlockTypes = [],
  allowImages = false,
  allowLinks = false,
} = {}) {
  return {
    inlineStyles: defaultPasteSupport.inlineStyles.filterNot(
      inlineStyle => disabledInlineStyles.includes(inlineStyle)
    ),
    blockTypes: defaultPasteSupport.blockTypes.filterNot(
      blockType => disabledBlockTypes.includes(blockType)
    ),
    images: defaultPasteSupport.images || allowImages,
    links: defaultPasteSupport.links || allowLinks,
  };
}

export default defaultPasteSupport;
